'use strict';

const SELECTORS = {
    swatchWrp: '.js-swatch-color',
    swatches: '.js-swatch-image',
    productTile: '.js-tile',
    imageContainer: '.js-tile-image',
    imageContainerUrl: '.js-tile-url',
    priceContainer: '.js-product-price'
};

/**
 * SwatchSelector class that handles the swatch color selection
 */
class SwatchSelector {
    constructor(element) {
        this.element = element;
        this.productTile = element.closest(SELECTORS.productTile);
        this.imageContainer = this.productTile.find(SELECTORS.imageContainer).eq(0);
        this.imageContainerUrl = this.productTile.find(SELECTORS.imageContainerUrl).eq(0);
        this.swatchSrc = element.attr('data-image');
        this.swatchAlt = element.attr('alt');
        this.swatchTitle = element.attr('title');
        this.href = element.closest('a').attr('href');
        this.priceObj = element.attr('data-price-obj');
        this.swatches = this.productTile.find(SELECTORS.swatches);
        this.firstSwatch = $(this.productTile).find('.js-wishlist-slider--selected').length > 0 ? $(this.productTile).find('.js-wishlist-slider--selected') : this.swatches.first();
        this.swatchesWrp = this.productTile.find(SELECTORS.swatchWrp);
        this.priceContainer = this.productTile.find(SELECTORS.priceContainer).eq(0);
        this.initEvents();
    }

    initEvents() {
        this.element.on('click', this.onSwatchClick.bind(this));
    }

    /**
     * Handles the swatch click, updates the selected state, and changes the image attributes
     */
    onSwatchClick(e) {
        e.preventDefault();
        e.stopPropagation();
        this.swatchesWrp.removeClass('selected');
        this.element.closest((SELECTORS.swatchWrp)).addClass('selected');
        this.updateImageAttributes();
        this.updatePrice();
    }
    /**
     * Updates the image container with the selected swatch's attributes
     */
    updateImageAttributes() {
        this.imageContainer.attr({
            src: this.swatchSrc,
            alt: this.swatchAlt,
            title: this.swatchTitle
        });
        this.imageContainerUrl.attr({
            href: this.href
        });
    }

    /**
     * Updates price template with selected swatch's attribute
     */
     updatePrice() {
        const price = JSON.parse(this.priceObj);
        const $priceContainer = this.productTile.find(SELECTORS.priceContainer).eq(0);
        if (price) {
            $priceContainer.replaceWith(price);
        }
    }
}

module.exports = {
    initializeClass: function () {
        $(SELECTORS.swatches).each((index, element) => {
        new SwatchSelector($(element));
        });
    }
};